<template>
  <div
    class="
      cvt-editor-grid-item-wrapper
      grid-stack-draggable-item grid-stack-item
      ui-draggable
      item-hover-border
    "
    :data-gs-x="dataX"
    :data-gs-y="dataY"
    :data-gs-width="dataWidth"
    :data-gs-height="dataHeight"
    :data-vnode-id="vnodeId"
    :gs-x="dataX"
    :gs-y="dataY"
    :gs-w="dataWidth"
    :gs-h="dataHeight"
    :gs-locked="false"
    :gs-auto-position="false"
    :data-gs-locked="false"
    @dblclick.stop=""
    @mouseenter="gridItemWrapperMouseEnter"
  >
    <div :class="contentWrapClasses">

      <div class="grid-item-actions">
        <span class="grid-stack-item-content ui-draggable-handle move-icon">
          <cvt-icon icon="arrows"/>
        </span>
      </div>

      <div
        v-if="isNonDraggableContent" 
        class="editable-element-overlay"
      >
        <cvt-button
          color="light"
          size="md"
          :mode="'LIGHT'"
          :text="editBtnText"
          :icon="'pencil'"
          :outlined="true"
          @click="toggleOverlay(false)"
        />
      </div>

      <div
        ref="content"
        class="d-flex w-100 grid-stack-item-element-content"
        :class="contentClasses"
      >
        <template v-for="node in fbNode.children">
          <template v-if="node.tag === 'sub-grid-container'">
            <sub-grid-container-v3 v-bind="node.data.props" :key="node.vnodeId" :fb-node="node"/>
          </template>
          <template v-else-if="node.children !== undefined">
            <component :is="node.tag" v-bind="node.data.props" :key="node.vnodeId" :fb-node="node">
              <template v-for="item in node.children">
                <component :is="item.tag" v-bind="item.data.props" :key="item.vnodeId" :fb-node="node"></component>
              </template>
            </component>
          </template>
          <template v-else>
            <component :is="node.tag" v-bind="node.data.props" :key="node.vnodeId" :fb-node="node"></component>
          </template>
        </template>
      </div>

      <action-buttons
          v-if="selectedChild"
          @duplicate="duplicateElement"
          @remove="removeElement"
      />

      <template v-if="fbNode.children.length === 0">
        <action-buttons :show-duplicate="false" @remove="forceRemoveElement" />
      </template>
    </div>

  </div>
</template>

<script>
import FirebaseNodeV3 from '../../base/FirebaseNode'
import { mapGetters } from 'vuex'
import * as getters from '../../../../store/modules/getters'
import GridItemWrapper from "../../../editor/nodes/GridItemWrapper.vue";
import Icon from "./Icon.vue";
import CButton from "./CButton.vue";
import DraftFroala from "./DraftFroala.vue";
import CImage from "./CImage.vue";
import CSurvey from "./CSurvey.vue";
import Divider from "./Divider.vue";
import CVideo from "./CVideo.vue";
import CForm from "./CForm.vue";
import BrandLogo from "./BrandLogo.vue";
import BuyNowButton from "./BuyNowButton.vue";
import CPopupBuilder from "./CPopupBuilder.vue";

const components = {
  'icon': Icon,
  'c-button':  CButton,
  'draft':  DraftFroala,
  'c-image':  CImage,
  'c-survey':  CSurvey,
  'divider':  Divider,
  'c-video':  CVideo,
  'c-form':  CForm,
  'brand-logo':  BrandLogo,
  'buy-now-button':  BuyNowButton,
  'c-popup-builder':  CPopupBuilder,
  // 'action-buttons':  ActionButtons,
}
export default GridItemWrapper.extend({
  name: 'GridItemWrapperV3',
  mixins: [FirebaseNodeV3],
  components: components,
  computed: {
    ...mapGetters({
      selectedComponent: getters.SELECTOR_SELECTED,
    }),
    selectedChild() {
      if (this.fbNode.children.length === 1) {
        return this.selectedComponent === this.$children[1]
      }
      return false
    },
  },
  methods: {
    duplicateElement () {
      if (this.fbNode.children.length === 1) {
        this.$emit('duplicateElement', this.fbNode)
      }
    },
    removeElement () {
      this.$emit('removeElement', this)
    },
    forceRemoveElement () {
      this.$emit('forceRemoveElement', this)
    },
    getChildComponentTag (val) {
      if (this.fbNode?.children?.length === 1) {
        return this.fbNode.children[0].tag
      }
    },
  },
  watch: {
    viewMode: {
      immediate: true,
      handler (newVal) {
        setTimeout(() => {
          this.$mount()
          this.triggerResizeChild()
        }, 400)
      },
    },
  },
})
</script>

